import React from 'react';
const LoadPlan = () => {
  return (
    <div className="text-center py-5 d-flex flex-column justify-content-center align-items-center h-100">
      <h5>Loading subscription plans...</h5>
      <div 
        className="spinner-border text-primary mt-3" 
        role="status"
        style={{fontSize: '8px', width: '100px', height: '100px'}}
      ></div>
    </div>
  );
};

export default LoadPlan;
